/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useState } from 'react';
import Panel from 'react-bootstrap/lib/Panel';
import { paths } from 'client/shared/Paths';
import { Button } from 'shared/Button/NewButton';
import { useT } from 'client/i18n/hooks/useT';
import { SectionHeading } from '../SettingsForm/styles';
import {
  DeleteAccountParagraph,
  DeleteContainerCss,
  OverridePanelCss,
} from './styles';

export function DeleteAccount() {
  const [showDelete, setShowDelete] = useState(false);
  const t = useT();

  return (
    <div css={OverridePanelCss}>
      <Panel
        onEnter={() => setShowDelete(true)}
        onExit={() => setShowDelete(false)}
        // @ts-ignore
        collapsible={true}
        header={
          <SectionHeading
            css={css`
              margin-bottom: 32px;
              @media (max-width: 600px) {
                margin-bottom: 36px;
              }
            `}
          >
            {t(
              'SettingsScreen.DeleteAccount.DeleteAccountHeader',
              'Delete account',
              'Delete Anchor account section header'
            )}{' '}
            {showDelete ? '\u25BE' : '\u25B8'}
          </SectionHeading>
        }
        eventKey="1"
      >
        <div css={DeleteContainerCss}>
          <DeleteAccountParagraph>
            {t(
              'SettingsScreen.DeleteAccount.DeleteAccountMessage',
              'We hope you love using Anchor, but if you need to delete your account you can do that here. If you delete your account, your podcast and all of its content will be permanently removed and cannot be recovered.',
              'Delete Anchor account disclaimer'
            )}
          </DeleteAccountParagraph>
          <DeleteAccountParagraph>
            {t(
              'SettingsScreen.DeleteAccount.DeleteAccountMoreInfoMessage',
              'Unsure about deleting your account? Reach out to us for help at {helpPageLink}.',
              'More information about deleting Anchor account message',
              {
                helpPageLink: (
                  <a
                    href={paths.getHelpPage('home')}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {paths.getHelpPage('home')}
                  </a>
                ),
              }
            )}
          </DeleteAccountParagraph>
          <Button
            kind="link"
            href="/dashboard/delete"
            height={40}
            color="red"
            css={css`
              @media (max-width: 600px) {
                width: 100%;
              }
            `}
          >
            {t(
              'SettingsScreen.DeleteAccount.DeleteButtonLabel',
              'Delete my account',
              'Delete Anchor account button text'
            )}
          </Button>
        </div>
      </Panel>
    </div>
  );
}
